// extracted by mini-css-extract-plugin
export default {"container":"CareRecipientHeader_container__1-8s6"};